import {Breadcrumbs, Btn, Image} from "../../../../../AbstractElements";
import {getApplicationRoute} from "../../../../../Route/RouteIndex";
import UpdateUserForm from "../../../../Privilege/User/Component/UpdateUserForm";
import React, {useContext, useEffect, useRef, useState} from "react";
import {Card, CardBody, CardHeader, Col, Container, Modal, ModalBody, ModalFooter, ModalHeader, Row} from "reactstrap";
import Loader from "../../../../../Layout/Loader";
import {BootstrapTabContainer, BootstrapTabContent} from "../../../../../CommonElements/BootstrapTabs";
import ButtonIcon from "../../../../../CommonElements/ButtonIcon";
import axiosConfig from "../../../../../Config/axios";
import {useParams} from "react-router";
import {useNavigate} from "react-router-dom";
import WalletTransactionsTable from "../../../Wallet/WalletTransaction/Component/WalletTransactionsTable";
import {ActivityLog} from "../../../../SystemCore/ActivityLog";
import AuthorizationContext from "../../../../../_helper/Authorization";
import type {AuthorizationContextType} from "../../../../../_helper/Authorization/AuthorizationTypes";
import {Participant} from "../../Types/ParticipantTypes";
import WalletContext from "../../../Wallet/Context";
import type {WalletContextType} from "../../../Wallet/Context/WalletContext.types";
import AdminZoneWallet from "../../../Wallet/Component/AdminZoneWallet";
import ParticipantDashboard from "../Component/ParticipantDashboard";
import BoardNumberIndex from "../../../Board/BoardNumber/Component/BoardNumberIndex";
import ContactTable from "../../../../SystemCore/Contact/Component/ContactTable";
import ContactForm from "../../../../SystemCore/Contact/Component/ContactForm";
import MultimediaService from "../../../../SystemCore/Multimedia/Services/Multimedia.service";
import type {Contact, ContactTableRef} from "../../../../SystemCore/Contact/Types/ContactTypes";
import ProfileImage from "../../../../CommonComponents/Profiles/ProfileImage";
import {MultimediaTable} from "../../../../SystemCore/Multimedia";
import WalletTransactionModal from "../../../Wallet/WalletTransaction/Component/WalletTransactionModal";

interface participantShowProps {

}

const ParticipantShow = ({}: participantShowProps) => {
    const [loaderVisibility, setLoaderVisibility] = useState<boolean>(false);
    const [transactionFormVisibility, setTransactionFormVisibility] = useState<boolean>(false);
    const [participant, setParticipant] = useState<Participant | null>(null);
    const [url, setUrl] = useState<string>('');
    const params = useParams();
    const navigate = useNavigate();
    const [contactModalVisibility, setContactModalVisibility] = useState<boolean>(false);
    const [selectedContact, setSelectedContact] = useState<Contact | undefined>();
    const contactTableRef = useRef<ContactTableRef>(null);
    const authContext = useContext(AuthorizationContext) as AuthorizationContextType;
    const walletContext = useContext(WalletContext) as WalletContextType;
    const {errorHandler, hasPermission} = authContext || {};
    const {getWalletInformation} = walletContext || {};
    const participantRoute = getApplicationRoute('participant', true);
    const canReadBoardNumber = !!(hasPermission && hasPermission('read-board-number'));
    const canReadWalletTransactions = !!(hasPermission && hasPermission('read-wallet-transaction'));

    useEffect(() => {
        getParticipant(params.participant);
    }, [params.participant]);

    const getParticipant = (participantID: string | undefined) => {
        if (!participantID) return;
        setLoaderVisibility(true);
        axiosConfig
            .get(`${getApplicationRoute('participant')}/${participantID}`)
            .then((response: { data: { data: Participant; }; }) => {
                if (response?.data?.data) {
                    setParticipant(response.data.data);
                } else {
                    navigate(participantRoute);
                }
                setLoaderVisibility(false);
            })
            .catch((exception: any) => {
                errorHandler(exception);
                setLoaderVisibility(false);
                navigate(participantRoute);
            });

    }

    const deleteParticipant = (id?: number) => {
        if (!id) return;
        setLoaderVisibility(true);
        axiosConfig
            .delete(`${getApplicationRoute('participant')}/${id}`, {})
            .then((response: { data: { data: { id: number; }; }; }) => {
                if (response?.data?.data) {
                    navigate(participantRoute);
                }
                setLoaderVisibility(false);
            })
            .catch((exception: any) => {
                errorHandler(exception);
                setLoaderVisibility(false);
            });
    }

    const readUrl = (event: React.ChangeEvent<HTMLInputElement>) => {
        if (!event.target.files || event.target.files.length === 0) return;
        const mimeType = event.target.files[0].type;

        if (mimeType.match(/image\/*/) == null) {
            return;
        }
        const reader = new FileReader();
        reader.readAsDataURL(event.target.files[0]);
        reader.onload = (_event) => {
            const readerResult = typeof reader.result === 'string' ? reader.result : '';
            setUrl(readerResult);
        };
    };

    const contactModalToggle = () => {
        if (contactModalVisibility) {
            setSelectedContact(undefined);
        }
        setContactModalVisibility(!contactModalVisibility);
    };

    const addContact = (contact: Contact) => {
        contactTableRef.current?.addContact(contact);
        contactModalToggle();
    };

    const openContactEditModal = (contact: Contact) => {
        setSelectedContact(contact);
        setContactModalVisibility(true);
    };

    const profileImageUrl = url
        || MultimediaService.resolveMultimediaUrl(participant?.avatar)
        || require('../../../../../assets/images/user/7.jpg');

    return (<div>
        <Breadcrumbs mainTitle="Participant Profile" parent="Application"
                     subParentLink={`${getApplicationRoute('participant')}`}
                     subParent={'Participants'} title={participant?.name}/>
        <Container fluid={true}>
            <div className="user-profile">
                <Loader visibility={loaderVisibility}/>
                <Row>
                    <Col sm='12' lg='3'>
                        <Card className='hovercard text-center'>
                            <CardHeader className='social-profile'>
                                <div className='d-flex align-items-center gap-2'>
                                </div>
                            </CardHeader>
                            <ProfileImage profileImageUrl={profileImageUrl} setUrl={setUrl} params={{
                                link_type_key: 'user',
                                link_type_id: participant?.user?.id,
                                single: true,
                                role: 'avatar',
                            }}/>
                            <div className='info'>
                                <Row className='step3' data-intro='This is the your details'>
                                    <Col sm='12' lg='12' className='order-sm-0 order-xl-1'>
                                        <div className='user-designation'>
                                            <div className='title'>
                                                <a>
                                                    {participant?.name}
                                                </a>
                                            </div>
                                        </div>
                                    </Col>
                                </Row>
                            </div>

                            <CardBody>
                                {participant?.pointWallet?.last_transaction && participant ? (
                                    getWalletInformation(participant?.pointWallet)) : null}

                                {participant?.cashWallet?.last_transaction && participant ? (
                                    getWalletInformation(participant?.cashWallet)
                                ) : null}

                                {!(participant?.cashWallet || participant?.pointWallet) && (
                                    <AdminZoneWallet
                                        relationKey="participant"
                                        relationId={participant?.id || ''}
                                        onSuccess={() => getParticipant(params.participant)}
                                    />
                                )}

                                <div className='social-network theme-form m-t-20'>
                                    <span className='f-w-600 text-danger'>Danger Zone</span>
                                    <ButtonIcon confirm={{confirm: true}}
                                                onclick={() => deleteParticipant(participant?.id)}
                                                type={'delete'} permission={'delete-participant'}/>
                                </div>
                            </CardBody>
                        </Card>
                    </Col>
                    <Col sm='12' lg='9'>
                        <Card className='hovercard'>
                            <CardBody>
                                <BootstrapTabContainer>
                                    <BootstrapTabContent title={'Dashboard'} icon={"icofont icofont-dashboard"}>
                                        {participant && <ParticipantDashboard participant={participant}/>}
                                    </BootstrapTabContent>

                                    {canReadBoardNumber && (
                                        <BootstrapTabContent title={'Board Numbers'}
                                                             icon={'icofont icofont-ui-calendar'}>
                                            <BoardNumberIndex params={{participant_id: participant?.id}}/>
                                        </BootstrapTabContent>
                                    )}

                                    {hasPermission && hasPermission('read-contact') && (
                                        <BootstrapTabContent title={'Contacts'}
                                                             icon={'icofont icofont-contact-add'}>
                                            <div className='d-flex justify-content-end mb-3'>
                                                {participant?.id && <ButtonIcon
                                                    attrBtn={{onClick: () => setContactModalVisibility(true)}}
                                                    type={'add'}
                                                    permission={'create-contact'}
                                                />}
                                            </div>
                                            <ContactTable
                                                ref={contactTableRef}
                                                params={{type: 'participant', id: participant?.id}}
                                                related_key={'participant'}
                                                related_id={participant?.id}
                                                onEdit={openContactEditModal}
                                            />
                                        </BootstrapTabContent>
                                    )}
                                    {
                                        participant?.point_wallet_id && participant && canReadWalletTransactions && (
                                            <BootstrapTabContent title={'Points'}
                                                                 icon={'icofont icofont-bank-transfer'}>
                                                <div className={'d-flex justify-content-between'}>
                                                    <div></div>
                                                    <div className='d-flex  gap-2'>
                                                        <ButtonIcon attrBtn={{
                                                            onClick: () => {
                                                                setTransactionFormVisibility(true)
                                                            }
                                                        }} type={'add'} permission={'create-wallet-transaction'}/>
                                                    </div>
                                                </div>

                                                <WalletTransactionsTable callBack={() => getParticipant(params.participant)}
                                                                         params={{wallet_id: participant.point_wallet_id}}/>
                                            </BootstrapTabContent>
                                        )
                                    }
                                    {
                                        participant?.cash_wallet_id && participant && canReadWalletTransactions && (
                                            <BootstrapTabContent title={'Cash'}
                                                                 icon={'icofont icofont-bank-transfer'}>
                                                <WalletTransactionsTable callBack={() => getParticipant(params.participant)}
                                                                         params={{wallet_id: participant.cash_wallet_id}}/>
                                            </BootstrapTabContent>
                                        )
                                    }
                                    {hasPermission && hasPermission('confirm-wallet-transaction') && (
                                        <BootstrapTabContent title={'Confirmations'} icon={'icofont icofont-check-alt'}>
                                            <WalletTransactionsTable
                                                params={{participant_id: participant?.id, status: 'unconfirmed'}}
                                                tableOptions={{confirm: true}}/>
                                        </BootstrapTabContent>
                                    )}
                                    {hasPermission && hasPermission('read-multimedia') && (
                                        <BootstrapTabContent title={'Multimedia'} icon={'icofont icofont-check-alt'}>
                                            <MultimediaTable
                                                params={{link_type_key: 'participant', link_type_id: participant?.id}}/>
                                        </BootstrapTabContent>
                                    )}
                                    {hasPermission && hasPermission('update-participant') && (
                                        <BootstrapTabContent title={'Update'} icon={'icofont icofont-ui-edit'}>
                                            <UpdateUserForm userData={participant?.user}/>
                                        </BootstrapTabContent>
                                    )}

                                    {hasPermission && hasPermission('read-activity-log') && (
                                        <BootstrapTabContent title={'Activity Log'} icon={'icofont icofont-list'}>
                                            {participant &&
                                                <ActivityLog subjectType="participant" subjectId={participant.id}/>}
                                        </BootstrapTabContent>
                                    )}

                                </BootstrapTabContainer>
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
            </div>

            {participant?.point_wallet_id && participant ?
                <WalletTransactionModal
                    isOpen={transactionFormVisibility}
                    attachmentRequired={true}
                    toggle={() => setTransactionFormVisibility(false)}
                    wallet_owner_id={participant.id}
                    wallet_current_balance={participant.pointWallet?.current_balance || 0}
                    transactionTypes={[
                        'transaction-type-point-purchase-collector-participant',
                        'transaction-type-point-purchase-system-participant'
                    ]}
                    action={'Purchase'}
                    onTransactionComplete={() => {
                        setTransactionFormVisibility(false);
                    }}
                />

                : null}


            {/*{participant?.point_wallet_id && participant ? (*/}
            {/*    <Modal isOpen={transactionFormVisibility} toggle={() => setTransactionFormVisibility(false)} centered>*/}
            {/*        <ModalHeader>*/}
            {/*            Buy Points*/}
            {/*        </ModalHeader>*/}
            {/*        <ModalBody>*/}
            {/*            <div className='d-flex gap-4 align-items-center mb-3'>*/}
            {/*                <label className='d-flex align-items-center gap-2 m-0'>*/}
            {/*                    <input*/}
            {/*                        type='radio'*/}
            {/*                        name='point_purchase_source'*/}
            {/*                        value='collector'*/}
            {/*                        checked={transactionType === 'transaction-type-point-purchase-collector-participant'}*/}
            {/*                        onChange={() => setTransactionType('transaction-type-point-purchase-collector-participant')}*/}
            {/*                    />*/}
            {/*                    <span>From Collector</span>*/}
            {/*                </label>*/}
            {/*                <label className='d-flex align-items-center gap-2 m-0'>*/}
            {/*                    <input*/}
            {/*                        type='radio'*/}
            {/*                        name='point_purchase_source'*/}
            {/*                        value='system'*/}
            {/*                        checked={transactionType === 'transaction-type-point-purchase-system-participant'}*/}
            {/*                        onChange={() => setTransactionType('transaction-type-point-purchase-system-participant')}*/}
            {/*                    />*/}
            {/*                    <span>From System</span>*/}
            {/*                </label>*/}
            {/*            </div>*/}
            {/*            <div style={{*/}
            {/*                display: 'flex',*/}
            {/*                flexWrap: 'nowrap',*/}
            {/*                overflowX: 'scroll'*/}
            {/*            }}>*/}
            {/*                {pricingList.map((pricing, key) => <Col xl="4 xl-50" sm="6" className="box-col-6 "*/}
            {/*                                                        style={{padding: 10}}*/}
            {/*                                                        key={key}>*/}
            {/*                    <WalletFixAmountForm callBack={() => {*/}
            {/*                        getParticipant(params.participant);*/}
            {/*                        setTransactionFormVisibility(false);*/}
            {/*                    }} price={pricing}*/}
            {/*                                         impactorID={participant.id}*/}
            {/*                                         transactionType={transactionType}/>*/}
            {/*                </Col>)}*/}
            {/*            </div>*/}
            {/*        </ModalBody>*/}
            {/*        <ModalFooter>*/}
            {/*            <Btn*/}
            {/*                attrBtn={{color: 'primary', onClick: () => setTransactionFormVisibility(false)}}>Close</Btn>*/}
            {/*        </ModalFooter>*/}
            {/*    </Modal>*/}
            {/*) : null}*/}

            {participant ? (
                <Modal isOpen={contactModalVisibility} toggle={contactModalToggle} centered>
                    <ModalHeader>{selectedContact ? 'Update' : 'Create'} Contact</ModalHeader>
                    <ModalBody>
                        <ContactForm
                            callBack={addContact}
                            contact={selectedContact}
                            related_key={'participant'}
                            related_id={participant.id}
                        />
                    </ModalBody>
                    <ModalFooter>
                        <Btn attrBtn={{color: 'primary', onClick: contactModalToggle}}>Close</Btn>
                    </ModalFooter>
                </Modal>
            ) : null}

        </Container>
    </div>);
}

export default ParticipantShow;

